export default __webpack_public_path__ + "static/media/AccountSetting.a6dc345c.svg";